import {
  FETCH_NOTIFICATIONS_START,
  FETCH_NOTIFICATIONS_SUCCESS,
  FETCH_NOTIFICATIONS_FAILURE,
  SET_FETCH_NOTIFICATION_PAGINATION,
  RESET_NOTIFICATION_DATA,
  FETCH_NOTIFICATION_BELL_COUNT_START,
  FETCH_NOTIFICATION_BELL_COUNT_SUCCESS
} from "./ActionConstant";

export function fetchNotificationsStart(data) {
  return {
    type: FETCH_NOTIFICATIONS_START,
    data,
  };
}

export function fetchNotificationsSuccess(data) {
  return {
    type: FETCH_NOTIFICATIONS_SUCCESS,
    data,
  };
}

export function fetchNotificationsFailure(error) {
  return {
    type: FETCH_NOTIFICATIONS_FAILURE,
    error,
  };
}

export function setNotificationPage(data) {
  return {
    type: SET_FETCH_NOTIFICATION_PAGINATION,
    data,
  }
}

export function resetNotificationData() {
  return {
    type: RESET_NOTIFICATION_DATA
  }
}

export function fetchNotificationBellCountStart() {
  return {
    type: FETCH_NOTIFICATION_BELL_COUNT_START
  }
}

export function fetchNotificationBellCountSuccess(data) {
  return {
    type: FETCH_NOTIFICATION_BELL_COUNT_SUCCESS,
    data
  }
}
